import React from 'react';
import { Card } from '../../../../../CommonComponents/OPL/Card/Card';
import { PeriodReturn } from '../../../PeriodReturn/PeriodReturn';

export const PeriodReturnCard = React.memo(() => {
  return (
    <Card p="16">
      <PeriodReturn />
    </Card>
  );
});
